"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularProgressContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const core_1 = require("@emotion/core");
const CircularProgressContainer = styled_1.default.div `
  .MuiCircularProgress-colorPrimary {
    color: ${(props) => (props.white ? 'white' : props.theme.colors.primary)} !important;

    ${(props) => props.small &&
    core_1.css `
        width: 20px !important;
        height: 20px !important;
      `}
  }
`;
exports.CircularProgressContainer = CircularProgressContainer;
